import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/const";
import { TRADING_NAME } from "@/constants/company";

type SeoProps = {
  title: string;
  description: string;
  image?: string;
  path?: string;
  ogType?: "website" | "article";
};

const SITE_NAME = TRADING_NAME;
const DEFAULT_OG_PATH = "/og-default.png";
const DEFAULT_OG = `${SITE_URL}${DEFAULT_OG_PATH}`;
const DEFAULT_OG_ALT = `${SITE_NAME} — AI-designed home energy systems`;

export default function Seo({ title, description, image, path = "", ogType = "website" }: SeoProps) {
  const url = `${SITE_URL}${path}`;
  const ogImage = image?.startsWith("http") ? image : `${SITE_URL}${image ?? DEFAULT_OG_PATH}`;
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} — ${SITE_NAME}`;
  const imageAlt = image ? fullTitle : DEFAULT_OG_ALT;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage || DEFAULT_OG} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage || DEFAULT_OG} />
      <meta name="twitter:image:alt" content={imageAlt} />
    </Helmet>
  );
}
